export const FILTER_TYPE = {
	checks: 'checks',
	textfield: 'textfield',
};

export const SORT_DIRECTION = {
	up: 'ASC',
	down: 'DESC',
};

export const SORT_LABEL = {
	[SORT_DIRECTION.up]: 'По возрастанию',
	[SORT_DIRECTION.down]: 'По убыванию',
};

export const getSortLabel = (direction) => SORT_LABEL[direction] ?? '';

export const VALUE_TYPE = {
	enum: 'enum',
	boolean: 'boolean',
	number: 'number',
	string: 'string',
	date: 'date',
};

export const FILTER_CLAUSE = {
	eq: 'eq',
	notEq: 'neq',
	in: 'in',
	notIn: 'notIn',
	null: 'isNull',
	notNull: 'isNotNull',
	moreThen: 'gt',
	lessThen: 'lt',
	inRange: 'range',
	yes: 'yes',
	no: 'no',
	contains: 'contains',
	notContains: 'notContains',
	last: 'lastDate',
	before: 'before',
	after: 'after',
	between: 'rangeDate',
	more: 'gtDate', // date from
	less: 'ltDate', // date till
};

export const filterEq = { label: 'Равно', value: FILTER_CLAUSE.eq };
export const filterNotEq = { label: 'Не равно', value: FILTER_CLAUSE.notEq };
export const filterEmpty = { label: 'Пусто', value: FILTER_CLAUSE.null };
export const filterNotEmpty = {
	label: 'Не пусто',
	value: FILTER_CLAUSE.notNull,
};

export const filterContains = {
	label: 'Содержит',
	value: FILTER_CLAUSE.contains,
};
export const filterNotContains = {
	label: 'Не содержит',
	value: FILTER_CLAUSE.notContains,
};

export const filterMore = { label: 'Больше', value: FILTER_CLAUSE.moreThen };
export const filterLess = { label: 'Меньше', value: FILTER_CLAUSE.lessThen };
export const filterInRange = {
	label: 'В диапазоне',
	value: FILTER_CLAUSE.inRange,
};
